import { getCurrentThemeName } from "../../theme";

/** Serif WERULE wordmark for auth screens (matches Figma). Hidden on NYC theme only. */
export const AuthWordmark = () => {
  if (getCurrentThemeName() === "black") {
    return null;
  }

  return (
    <span className="auth-wordmark" aria-label="WERULE">
      WERULE
    </span>
  );
};
